// audioUtils.js

// 1. Convert AudioBuffer to WAV Blob
export function bufferToWave(abuffer, len) {
  let numOfChan = abuffer.numberOfChannels,
      length = len * numOfChan * 2 + 44,
      buffer = new ArrayBuffer(length),
      view = new DataView(buffer),
      channels = [], i, sample,
      offset = 0,
      pos = 0;

  // write WAVE header
  setUint32(0x46464952);                         // "RIFF"
  setUint32(length - 8);                         // file length - 8
  setUint32(0x45564157);                         // "WAVE"

  setUint32(0x20746d66);                         // "fmt " chunk
  setUint32(16);                                 // length = 16
  setUint16(1);                                  // PCM (uncompressed)
  setUint16(numOfChan);
  setUint32(abuffer.sampleRate);
  setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
  setUint16(numOfChan * 2);                      // block-align
  setUint16(16);                                 // 16-bit (hardcoded in this example)

  setUint32(0x61746164);                         // "data" - chunk
  setUint32(length - pos - 4);                   // chunk length

  // write interleaved data
  for(i = 0; i < abuffer.numberOfChannels; i++)
    channels.push(abuffer.getChannelData(i));

  while(pos < len) {
    for(i = 0; i < numOfChan; i++) {             // interleave channels
      sample = Math.max(-1, Math.min(1, channels[i][pos])); // clamp
      sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767)|0; // scale to 16-bit signed int
      view.setInt16(44 + offset, sample, true);  // write 16-bit sample
      offset += 2;
    }
    pos++;
  }

  return new Blob([buffer], {type: "audio/wav"});

  function setUint16(data) {
    view.setUint16(pos, data, true);
    pos += 2;
  }

  function setUint32(data) {
    view.setUint32(pos, data, true);
    pos += 4;
  }
}

// 2. Buffer Manipulation Helpers
export const sliceAudioBuffer = (audioBuffer, start, end, audioContext) => {
    const channels = audioBuffer.numberOfChannels;
    const rate = audioBuffer.sampleRate;
    const startOffset = rate * start;
    const endOffset = rate * end;
    const frameCount = endOffset - startOffset;
    
    const newBuffer = audioContext.createBuffer(channels, frameCount, rate);
    
    for (let i = 0; i < channels; i++) {
        const channelData = audioBuffer.getChannelData(i);
        const newChannelData = newBuffer.getChannelData(i);
        // Copy data within range
        for (let j = 0; j < frameCount; j++) {
             newChannelData[j] = channelData[startOffset + j];
        }
    }
    return newBuffer;
};

   // audioUtils.js - Add this at the bottom
export function mixAudioBuffers(buffers, audioContext) {
    if (buffers.length === 0) return null;
    
    // 1. Find the longest buffer
    const maxLen = Math.max(...buffers.map(b => b.length));
    const maxChannels = Math.max(...buffers.map(b => b.numberOfChannels));
    const rate = buffers[0].sampleRate;

    // 2. Create the output buffer
    const output = audioContext.createBuffer(maxChannels, maxLen, rate);

    // 3. Sum the signals (Mixing)
    for (let i = 0; i < maxChannels; i++) {
        const outputData = output.getChannelData(i);
        for (const buffer of buffers) {
            if (i < buffer.numberOfChannels) {
                const inputData = buffer.getChannelData(i);
                for (let j = 0; j < inputData.length; j++) {
                    outputData[j] += inputData[j]; // Simple additive mixing
                }
            }
        }
    }
    return output;
}